var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"quiz-creator-loader flex justify-center items-center w-full h-full absolute"},[_c('div',[_c('div'),_c('div')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }